import type { CreateUserSchema, UpdateUserSchema } from '@/api/users/user.schema';
import type { User } from 'generated/prisma/browser';
import { createCrudHooks } from './create-crud-hooks';

export const {
  keys: userKeys,
  useDetail: useUser,
  useList: useUsers,
  useCreate: useCreateUser,
  useUpdate: useUpdateUser,
  useDelete: useDeleteUser,
} = createCrudHooks<User, CreateUserSchema, UpdateUserSchema>('users');
